import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Header from '../components/Header';
import Footer from '../components/Footer';
import Sidebar from '../components/Sidebar';
import Main from '../components/Main';
import LoginForm from '../components/LoginForm';
import { hiddenSidebar, showSidebar } from '../actions/admin/layout';

const AdminContainer = ({
  location,
  auth,
  show,
  showSidebar,
  hiddenSidebar,
}) => {
  const [className, setClassName] = useState('page-wrapper');

  useEffect(() => {
    // if (show) {
    //   if (
    //     location.pathname.indexOf("admin/advertisement/add") === 1 ||
    //     location.pathname.indexOf("admin/advertisement/edit") === 1
    //   ) {
    //     setClassName("page-wrapper show-sidebar ads-page");
    //   } else {
    //     setClassName("page-wrapper show-sidebar");
    //   }
    // } else {
    //   if (
    //     location.pathname.indexOf("admin/advertisement/add") === 1 ||
    //     location.pathname.indexOf("admin/advertisement/edit") === 1
    //   ) {
    //     setClassName("page-wrapper ads-page");
    //   } else {
    //     setClassName("page-wrapper");
    //   }
    // }
    if (show) {
      setClassName('page-wrapper show-sidebar');
    } else {
      setClassName('page-wrapper');
    }
  }, [show, location]);

  useEffect(() => {
    showSidebar();
  }, [showSidebar]);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth > 768) {
        // If viewing on large screen, always show the sidebar
        showSidebar();
      }
    }
    window.addEventListener('resize', handleResize);
  }, []);

  const onTouchScreen = () => {
    if (show && window.innerWidth < 768) {
      hiddenSidebar();
    }
  };

  return (

    <div className="app-layout" onClick={() => onTouchScreen()}>
      <div className={className}>
        {
          auth.isAuthenticated ? (
            <>
              <div className="row">
                <div className="col-sm-12 d-md-none">
                  <Header />
                </div>
                <div className="col-lg-12">
                  <Main />
                </div>
                <Sidebar />
              </div>
              {/* <Footer /> */}
            </>
          ) : (
            <div className="non-logged">
              <div className="row">
                <div className="col-md-3 col-lg-4" />
                <div className="col-md-6 col-lg-4">
                  <LoginForm />
                </div>
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
};

AdminContainer.propTypes = {
  auth:          PropTypes.object.isRequired,
  hiddenSidebar: PropTypes.func.isRequired,
  showSidebar:   PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  show: state.admin.layout.show,
});

export default connect(mapStateToProps, { hiddenSidebar, showSidebar })(
  AdminContainer,
);
